import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { LocalityInterface } from 'src/app/util/interfaces/locality';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SiteService {
	private postSiteURL = environment.baseApiUrl + 'location/createSite';
	private updateSiteURL = environment.baseApiUrl + 'location/updateSite/{id}';
	private searchSiteURL = environment.baseApiUrl + 'location/searchSite';
	private deactivateSiteURL = environment.baseApiUrl + 'location/inactiveSite/{id}';
	private activateSiteURL = environment.baseApiUrl + 'location/activeSite/{id}';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	// Todos os site
	getAllSites(): Observable<LocalityInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.searchSiteURL, { headers: headers });
	}

	// Sites por id
	getSiteById(id: string): Observable<LocalityInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const searchSiteURL = this.searchSiteURL + '?id=' + id;

		return this.httpClient.get<any>(searchSiteURL, { headers: headers }).pipe(
			map((siteReceived) => {
				siteReceived = siteReceived[0];
				const newSite: LocalityInterface = {
					id: siteReceived.id,
					site: siteReceived.site,
					activeSite: siteReceived.active,
				};
				return newSite;
			})
		);
	}

	// Adiciona um site
	postSite(form: LocalityInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			site: form.site,
		};
		return this.httpClient.post(this.postSiteURL, body, { headers: headers });
	}

	// Atualiza um site
	updateSite(formUpdate: LocalityInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const updateSiteURL = this.updateSiteURL.replace('{id}', formUpdate.id);
		const body = {
			site: formUpdate.site,
		};
		return this.httpClient.put(updateSiteURL, body, { headers: headers });
	}

	deactivateSite(customInterface: LocalityInterface) {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deactivateSiteUrl = this.deactivateSiteURL.replace('{id}', customInterface.id);
		return this.httpClient.delete<any>(deactivateSiteUrl, { headers: headers });
	}

	activateSite(customInterface: LocalityInterface) {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const activateSiteUrlId = this.activateSiteURL.replace('{id}', customInterface.id);

		return this.httpClient.get<any>(activateSiteUrlId, { headers: headers });
	}
}
